<template>
<div class="chapter">
<div class="inner_page">
<div id="fm2">
<p class="title"><span>DEON MEYER</span></p>
<p class="title1"><span class="bold">SEVEN DAYS</span></p>
<p class="title2"><em class="italic">Translated from Afrikaans</em></p>
<p class="title3"><em class="italic">by K. L. Seegers</em></p>
<p style="text-align: center; margin-top: 10em">
<img alt="image_0001" class="imgepub" src="images/image_0001.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?646a3015